module.exports = __webpack_public_path__ + "assets/AirbnbCereal-Light.0eba56270af9a809f11f590f3aba27d1.woff";